import { Bird } from 'lucide-react';
import { useNestPair } from '../hooks/useNestPair';

export default function NestPairCard() {
    const { title, status, loading, error } = useNestPair();

    return (
        <div className="group flex w-full shrink-0 items-center gap-5 rounded-3xl border border-gray-200 bg-white p-6 md:w-auto md:max-w-sm">
            <Bird
                className="size-9 shrink-0 text-green-500 transition-colors group-hover:text-green-600"
                strokeWidth={1.35}
                aria-hidden
            />
            <div className="min-w-0 flex-1">
                {error && !loading && (
                    <p className="text-sm sm:text-xs text-red-600">{error}</p>
                )}
                {loading ? (
                    <div className="space-y-2 animate-pulse">
                        <div className="h-5 sm:h-4 bg-gray-100 rounded w-36 sm:w-32" />
                        <div className="h-4 sm:h-3 bg-gray-100 rounded max-w-[12rem] sm:max-w-[11rem]" />
                    </div>
                ) : (
                    <>
                        <div className="text-base sm:text-sm font-bold text-gray-900 leading-snug sm:leading-tight">
                            {title || '—'}
                        </div>
                        {status ? (
                            <p className="text-sm sm:text-xs text-gray-600 font-medium mt-2 leading-snug whitespace-pre-line">{status}</p>
                        ) : null}
                    </>
                )}
            </div>
        </div>
    );
}
